import { Component, OnInit } from '@angular/core';
// eslint-disable-next-line no-restricted-imports
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { ApAlertService } from 'webcommon/core-ui';
import { FcCorporationListItemDto, FcModifyCorporationListItemDto } from 'webcommon/shared';
import { FcGenericItemModalBaseComponent } from '../../generic/fc-generic-item-modal-base.component';
import { FcListValidationService } from '../../generic/fc-list-validation/fc-list-validation.service';

@Component({
  providers: [ApAlertService, FcListValidationService],
  selector: 'fc-corporation-list-modal',
  templateUrl: './fc-corporation-list-modal.component.html',
})
export class FcCorporationListModalComponent extends FcGenericItemModalBaseComponent implements OnInit {
  public override baseId = 'fc-corporation-item';

  // List Item with default value
  public listItem: FcCorporationListItemDto = {
    Id: '',
    ExternalID: '',
    Name: '',
    PrimaryContact: '',
    SecondaryContact: '',
    Address: {
      Address1: '',
      Address2: '',
      City: '',
      State: '',
      Zip: '',
      CountyName: '',
      CountyCode: '',
    },
    Phone1: {
      PhoneNumber: '',
      PhoneType: '',
      PhoneTypeUid: '',
    },
    Phone2: {
      PhoneNumber: '',
      PhoneType: '',
      PhoneTypeUid: '',
    },
    Phone3: {
      PhoneNumber: '',
      PhoneType: '',
      PhoneTypeUid: '',
    },
    Phone4: {
      PhoneNumber: '',
      PhoneType: '',
      PhoneTypeUid: '',
    },
    Email1: '',
    Email2: '',
    CorpNotes: '',
    Inactive: false,
  };

  public corpNotesControl = new UntypedFormControl();
  public inactiveControl = new UntypedFormControl();

  public form = new UntypedFormGroup({
    corpNotes: this.corpNotesControl,
    inactive: this.inactiveControl,
  });

  override ngOnInit() {
    super.ngOnInit();

    // Load List Item and set default validation rules
    this.loadListItem({
      CorpNotes: {
        MaxLength: 65535,
      }
    });
  }

  public setForm(): void {
    // Notes Control
    this.corpNotesControl.setValidators(this.fcListValidation.getValidators('Notes'));
    this.corpNotesControl.setValue(this.listItem.CorpNotes);

    // Inactive Control
    this.inactiveControl.setValue(this.listItem.Inactive);

    this.validateForm();
  }

  public override save(): void {
    const values = this.form.getRawValue();
    this.isSubmitted = true;

    const modifyItemDto: FcModifyCorporationListItemDto = {
      ExternalID: values.externalId,
      Name: values.name,
      PrimaryContact: values.primaryContact,
      SecondaryContact: values.secondaryContact,
      Address: {
        Address1: values.address.addressOne,
        Address2: values.address.addressTwo,
        City: values.address.city,
        State: values.address.state,
        Zip: values.address.zip,
        Country: values.address.country,
        CountyName: values.address.countyName,
        CountyCode: values.address.countyCode,
      },
      Email1: values.emailOne,
      Email2: values.emailTwo,
      CorpNotes: values.corpNotes,
      Inactive: values.inactive,
    };

    if (values.phoneOne.phoneNumber && values.phoneOne.phoneType && values.phoneOne.phoneTypeUid) {
      modifyItemDto.Phone1 = {
        PhoneNumber: values.phoneOne.phoneNumber,
        PhoneType: values.phoneOne.phoneType,
        PhoneTypeUid: values.phoneOne.phoneTypeUid,
      };
    }
    if (values.phoneTwo.phoneNumber && values.phoneTwo.phoneType && values.phoneTwo.phoneTypeUid) {
      modifyItemDto.Phone2 = {
        PhoneNumber: values.phoneTwo.phoneNumber,
        PhoneType: values.phoneTwo.phoneType,
        PhoneTypeUid: values.phoneTwo.phoneTypeUid,
      };
    }
    if (values.phoneThree.phoneNumber && values.phoneThree.phoneType && values.phoneThree.phoneTypeUid) {
      modifyItemDto.Phone3 = {
        PhoneNumber: values.phoneThree.phoneNumber,
        PhoneType: values.phoneThree.phoneType,
        PhoneTypeUid: values.phoneThree.phoneTypeUid,
      };
    }
    if (values.phoneFour.phoneNumber && values.phoneFour.phoneType && values.phoneFour.phoneTypeUid) {
      modifyItemDto.Phone4 = {
        PhoneNumber: values.phoneFour.phoneNumber,
        PhoneType: values.phoneFour.phoneType,
        PhoneTypeUid: values.phoneFour.phoneTypeUid,
      };
    }

    super.save<FcModifyCorporationListItemDto>(modifyItemDto);
  }
}
